import { Dispatch } from "redux";
import {
  getLeaveRequests,
  createLeaveRequest,
  updateLeaveRequest,
  deleteLeaveRequest,
  updateStatusLeaveRequest,
} from "../../services/LeaveRequestService";
import { LeaveRequest } from "../../types/LeaveRequest";

export enum LeaveRequestActionType {
  FETCH_LEAVE_REQUESTS = "FETCH_LEAVE_REQUESTS",
  ADD_LEAVE_REQUEST = "ADD_LEAVE_REQUEST",
  EDIT_LEAVE_REQUEST = "EDIT_LEAVE_REQUEST",
  EDIT_LEAVE_STATUS = "EDIT_LEAVE_STATUS",
  DELETE_LEAVE_REQUEST = "DELETE_LEAVE_REQUEST",
}

export interface FetchLeaveRequests {
  type: LeaveRequestActionType.FETCH_LEAVE_REQUESTS;
  data: LeaveRequest[];
}

export interface AddLeaveRequest {
  type: LeaveRequestActionType.ADD_LEAVE_REQUEST;
  data: LeaveRequest;
}

export interface EditLeaveRequest {
  type: LeaveRequestActionType.EDIT_LEAVE_REQUEST;
  data: LeaveRequest;
}

export interface DeleteLeaveRequest {
  type: LeaveRequestActionType.DELETE_LEAVE_REQUEST;
  data: number;
}

export interface EditLeaveStatus {
  type: LeaveRequestActionType.EDIT_LEAVE_STATUS;
  data: LeaveRequest;
}

export type LeaveRequestAction =
  | FetchLeaveRequests
  | AddLeaveRequest
  | EditLeaveRequest
  | DeleteLeaveRequest
  | EditLeaveStatus;

export const fetchLeaveRequests = () => async (dispatch: Dispatch) => {
  const data = await getLeaveRequests();
  dispatch<FetchLeaveRequests>({
    type: LeaveRequestActionType.FETCH_LEAVE_REQUESTS,
    data,
  });
};

export const addLeaveRequest =
  (req: LeaveRequest) => async (dispatch: Dispatch) => {
    const response = await createLeaveRequest(req);
    dispatch<AddLeaveRequest>({
      type: LeaveRequestActionType.ADD_LEAVE_REQUEST,
      data: response.data,
    });
  };

export const editLeaveRequest =
  (id: number, req: LeaveRequest) => async (dispatch: Dispatch) => {
    const response = await updateLeaveRequest(id, req);
    dispatch<EditLeaveRequest>({
      type: LeaveRequestActionType.EDIT_LEAVE_REQUEST,
      data: response.data,
    });
  };
export const editLeaveStatus =
  (id: number, req: LeaveRequest) => async (dispatch: Dispatch) => {
    const response = await updateStatusLeaveRequest(id, req);
    dispatch<EditLeaveStatus>({
      type: LeaveRequestActionType.EDIT_LEAVE_STATUS,
      data: response.data,
    });
  };

export const deleteLeaveRequestById =
  (id: number) => async (dispatch: Dispatch) => {
    await deleteLeaveRequest(id);
    dispatch<DeleteLeaveRequest>({
      type: LeaveRequestActionType.DELETE_LEAVE_REQUEST,
      data: id,
    });
  };
